import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// slices

import analyticsReducer from "./slices/analytics";
import blogReducer from "./slices/blog";
import categoryReducer from "./slices/category";
import cateringReducer from "./slices/catering";
import contactReducer from "./slices/contact";
import enquiryChartReducer from "./slices/enquiry-chart";
import faqReducer from "./slices/faq";
import galleryReducer from "./slices/gallery";
import noticeReducer from "./slices/notice";
import notificationReducer from "./slices/notification";
import orderReducer from "./slices/order";
import pageReducer from "./slices/page";
import productReducer from "./slices/product";
import riderReducer from "./slices/rider";
import roleReducer from "./slices/role";
import stockHistoryReducer from "./slices/stockHistory";
import tagReducer from "./slices/tag";
import userReducer from "./slices/user";
import sitemapReducer from "./slices/sitemap";
import promoCodeReducer from "./slices/promoCode";
import dashboardDataReducer from "./slices/dashboard";
import printerReducer from "./slices/printer";

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const analyticsPersistConfig = {
  key: "analytics",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const blogPersistConfig = {
  key: "blog",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const categoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const productPersistConfig = {
  key: "product",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const galleryPersistConfig = {
  key: "gallery",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const contactPersistConfig = {
  key: "contact",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const userPersistConfig = {
  key: "user",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const orderPersistConfig = {
  key: "order",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const faqPersistConfig = {
  key: "faq",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const cateringPersistConfig = {
  key: "catering",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const noticePersistConfig = {
  key: "notice",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

// tag
export const tagPersistConfig = {
  key: "tag",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

// rider
export const riderPersistConfig = {
  key: "rider",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

// notification
export const notificationPersistConfig = {
  key: "notification",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

// enquiry chart
export const enquiryChartPersistConfig = {
  key: "enquiryChart",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

// role
export const rolePersistConfig = {
  key: "role",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const pagePersistConfig = {
  key: "page",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const stockHistoryPersistConfig = {
  key: "stockHistory",
  storage,
  keyPrefix: "redux-",
  whitelist: ["sortBy", "checkout"],
};

export const sitemapPersistConfig = {
  key: "sitemap",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const promoCodePersistConfig = {
  key: "promoCode",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const dashboardDataPersistConfig = {
  key: "dashboardData",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  blog: persistReducer(blogPersistConfig, blogReducer),
  category: persistReducer(categoryPersistConfig, categoryReducer),
  gallery: persistReducer(galleryPersistConfig, galleryReducer),
  product: persistReducer(productPersistConfig, productReducer),
  contact: persistReducer(contactPersistConfig, contactReducer),
  user: persistReducer(userPersistConfig, userReducer),
  order: persistReducer(orderPersistConfig, orderReducer),
  faq: persistReducer(faqPersistConfig, faqReducer),
  catering: persistReducer(cateringPersistConfig, cateringReducer),
  analytics: persistReducer(analyticsPersistConfig, analyticsReducer),
  notice: persistReducer(noticePersistConfig, noticeReducer),
  tag: persistReducer(tagPersistConfig, tagReducer),
  rider: persistReducer(riderPersistConfig, riderReducer),
  notification: persistReducer(notificationPersistConfig, notificationReducer),
  enquiryChart: persistReducer(enquiryChartPersistConfig, enquiryChartReducer),
  role: persistReducer(rolePersistConfig, roleReducer),
  stockHistory: persistReducer(stockHistoryPersistConfig, stockHistoryReducer),
  page: persistReducer(pagePersistConfig, pageReducer),
  sitemap: persistReducer(sitemapPersistConfig, sitemapReducer),
  promoCode: persistReducer(promoCodePersistConfig, promoCodeReducer),
  dashboardData: persistReducer(
    dashboardDataPersistConfig,
    dashboardDataReducer,
  ),
  printer: printerReducer,
});

export default rootReducer;
